import React, { useState } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import {
  Card,
  CardHeader,
  CardContent,
  Divider,
  CardActions,
  Button,
  Typography,
  TextField,
} from "@material-ui/core";
import { useTranslation } from "react-i18next";

const RFID_PATTERN = /^[^\s]{3,30}$/;

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  button: {
    minWidth: 100,
    backgroundColor: "#030f40",
    padding: 10,
    color: "#fff",
    borderRadius: 15,
    "&:hover": {
      backgroundColor: "#00B0EC",
    },
  },
  header: {
    padding: 10,
  },
  field: {
    width: "100%",
  },
}));

const InputQRCodeModal = ({ open, onCloseModal, onSubmit }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const [rfid, setRfid] = useState("");
  const [error, setError] = useState("");

  const handleClose = () => {
    setRfid("");
    setError("");
    onCloseModal();
  };

  const handleSubmit = () => {
    if (!RFID_PATTERN.test(rfid)) {
      setError(t("error.qrcode_format"));
      return;
    }
    onSubmit(rfid);
    setRfid("");
    setError("");
  };

  return (
    <Modal
      className={classes.modal}
      open={open}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{ timeout: 500 }}
    >
      <Fade in={open}>
        <Card>
          <CardHeader
            className={classes.header}
            title={<Typography variant="h6">{t("input_qrcode")}</Typography>}
          />
          <Divider />
          <CardContent>
            <TextField
              className={classes.field}
              label={t("input_qrcode_label")}
              value={rfid}
              onChange={(e) => {
                setRfid(e.target.value);
                setError("");
              }}
              error={!!error}
              helperText={error || t("input_qrcode_hint")}
              inputProps={{ maxLength: 30 }}
              autoFocus
            />
          </CardContent>
          <Divider />
          <CardActions>
            <Button onClick={handleSubmit} classes={{ root: classes.button }}>
              {t("generate_qrcode")}
            </Button>
            <Button onClick={handleClose} classes={{ root: classes.button }}>
              {t("cancel")}
            </Button>
          </CardActions>
        </Card>
      </Fade>
    </Modal>
  );
};

InputQRCodeModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onCloseModal: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default InputQRCodeModal;
